import { StatutoryTerritorialScope } from "@entity/domain/models/statutory-territorial-scope/statutory-territorial-scope.model";

export class CreateStatutoryTerritorialScope {
    constructor(
        public name: StatutoryTerritorialScope["name"],
        public scope: StatutoryTerritorialScope["scope"],
        public entity: StatutoryTerritorialScope["entity"],
    ) {}
}
